/** Menu names used in BI event keys. Keep keys in alphabetical order; lint enforces this. */
export const MENU_NAMES = {
  ALIGN_NODES_SUBMENU: 'align_nodes_submenu',
  ASSET_TILE: 'asset_tile',
  ASSET_TOOLBAR: 'asset_toolbar',
  AUDIT_TRAIL_CARD: 'audit_trail_card',
  BLUR_NODE: 'blur_node',
  CHANNELS_NODE: 'channels_node',
  CLEAR_ASSETS_SUBMENU: 'clear_assets_submenu',
  COLOR_CORRECTION_NODE: 'color_correction_node',
  COMMUNITY_PUBLISH_STATUS_BANNER: 'community_publish_status_banner',
  COMP_NODE_V3: 'comp_node_v3',
  CREATED_BY_FILTER_DROPDOWN: 'created_by_filter_dropdown',
  DASHBOARD_FOLDER: 'dashboard_folder',
  DASHBOARD_MAIN: 'dashboard_main',
  DASHBOARD_TOOL: 'dashboard_tool',
  DASHBOARD_WORKFLOW: 'dashboard_workflow',
  DELETE_ASSETS: 'delete_assets',
  DESIGNER_EDITOR: 'designer_editor',
  DESIGN_APP: 'design_app',
  DESIGN_APP_INPUT: 'design_app_input',
  DOTS_MENU: 'dots_menu',
  DOWNLOAD_MENU: 'download_menu',
  EXTRACT_VIDEO_FRAME_NODE: 'extract_video_frame_node',
  FIGMA_EMBED_FILENAME_DROPDOWN_MENU: 'figma_embed_filename_dropdown_menu',
  FIGMA_EMBED_FILE_MENU: 'figma_embed_file_menu',
  FIGMA_EMBED_HELP_AND_ACCOUNT_MENU: 'figma_embed_help_and_account_menu',
  FIGMA_EMBED_VIEWER_FILE_MENU: 'figma_embed_viewer_file_menu',
  FIGMA_NODE: 'figma_node',
  FIGMA_NODE_ADD_INPUT_MENU_ITEMS: 'figma_node_add_input_menu_items',
  FIGMA_NODE_CONNECT_MENU: 'figma_node_connect_menu',
  FILE_VIEWER: 'file_viewer',
  FILE_VIEWER_OVERLAY: 'file_viewer_overlay',
  GALLERY: 'gallery',
  GROUP_CONTEXT_MENU: 'group_context_menu',
  HANDLE_COLLAPSE: 'handle_collapse',
  IMPORT_NODE: 'import_node',
  INVERT_NODE: 'invert_node',
  LAYER_EFFECTS: 'layer_effects',
  LEVELS_NODE: 'levels_node',
  LORA: 'lora',
  MODEL_BASE_NODE: 'model_base_node',
  MODEL_NODE: 'model_node',
  MULTI_SELECTION_CONTEXT_MENU: 'multi_selection_context_menu',
  NAVIGATION_DRAWER: 'navigation_drawer',
  NODE: 'node',
  NODE_AUDIT_TRAIL_MENU_GROUP: 'node_audit_trail_menu_group',
  NODE_HISTORY: 'node_history',
  NODE_HISTORY_ROW: 'node_history_row',
  NODE_MENU: 'node_menu',
  PAINTER_NODE: 'painter_node',
  PREVIEW_NODE_V2: 'preview_node_v2',
  PROMPT_EDITOR_MENU_ITEMS: 'prompt_editor_menu_items',
  RESIZE_NODE: 'resize_node',
  SAVED_BY_FILTER_BUTTON: 'saved_by_filter_button',
  SHAPES_MENU: 'shapes_menu',
  SORT_ORDER_MENU: 'sort_order_menu',
  STICKY_NOTE_CONTEXT_MENU: 'sticky_note_context_menu',
  TEAM_ROLE_SELECT: 'team_role_select',
  TEAM_TABLE_MENU: 'team_table_menu',
  TIME_INPUT: 'time_input',
  TOOL_SHARE: 'tool_share',
  WORKFLOW: 'workflow',
  WORKFLOW_FILE_MENU: 'workflow_file_menu',
  WORKFLOW_SHARE: 'workflow_share',
  WORKSPACES_MENU: 'workspaces_menu',
  ZOOM_MENU: 'zoom_menu',
} as const;
